import { PropsOf } from 'types';
import connect from './connect';
import SocialIconsBottomBar, { IProps } from './SocialIconsBottomBar';

export default connect(SocialIconsBottomBar);

export type SocialIconsBottomBarProps = PropsOf<ReturnType<typeof connect>>;

export { IProps as ISocialIconsBottomBarProps };
